import axios from 'axios';

export function shuffleArray(array) {
  // based on https://stackoverflow.com/a/2450976/3566861
  var currentIndex = array.length, temporaryValue, randomIndex;
  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
};

export function getJson(file){
  return axios.get(file);
}


/** WEBPACK FOOTER **
 ** ./src/helpers.js
 **/